import { render, staticRenderFns } from "./EmptyCommentCard.vue?vue&type=template&id=a6687abc&"
import script from "./EmptyCommentCard.vue?vue&type=script&lang=ts&"
export * from "./EmptyCommentCard.vue?vue&type=script&lang=ts&"
import style0 from "./EmptyCommentCard.vue?vue&type=style&index=0&id=a6687abc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports